import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";

const Login = () => {
  const { loginWithGoogle, loginWithEmail, signupWithEmail } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [showEmailForm, setShowEmailForm] = useState(false);
  const [isSignup, setIsSignup] = useState(false);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const handleGoogleLogin = async () => {
    setLoading(true);
    setError("");
    try {
      await loginWithGoogle();
      navigate("/");
    } catch (err) {
      console.error(err);
      setError("Falha no login com Google. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      if (isSignup) {
        await signupWithEmail(email, password);
      } else {
        await loginWithEmail(email, password);
      }
      navigate("/");
    } catch (err) {
      console.error("Email auth error:", err);
      if (err.code === "auth/user-not-found") {
        setError("Usuário não encontrado");
      } else if (err.code === "auth/wrong-password") {
        setError("Senha incorreta");
      } else if (err.code === "auth/email-already-in-use") {
        setError("Email já está em uso");
      } else if (err.code === "auth/weak-password") {
        setError("Senha muito fraca. Use no mínimo 6 caracteres");
      } else if (err.code === "auth/invalid-email") {
        setError("Email inválido");
      } else {
        setError("Erro ao autenticar. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  const socialButtonStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: "var(--radius-sm)",
    border: "1px solid var(--border-color)",
    backgroundColor: "var(--white)",
    color: "var(--text-primary)",
    fontWeight: "bold",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "10px",
    marginBottom: "10px",
    transition: "background-color 0.2s",
    fontSize: "16px",
  };

  const inputStyle = {
    width: "100%",
    padding: "12px",
    borderRadius: "var(--radius-sm)",
    border: "1px solid var(--border-color)",
    fontSize: "16px",
    marginBottom: "15px",
    boxSizing: "border-box",
  };

  const submitButtonStyle = {
    ...socialButtonStyle,
    backgroundColor: "var(--primary-color)",
    color: "white",
    border: "none",
  };

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "calc(100vh - 200px)",
        backgroundColor: "var(--background-color)",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "400px",
          padding: "var(--spacing-xl)",
          backgroundColor: "var(--white)",
          borderRadius: "var(--radius-md)",
          boxShadow: "var(--shadow-md)",
          textAlign: "center",
        }}
      >
        <h2
          style={{
            marginBottom: "var(--spacing-lg)",
            color: "var(--primary-color)",
          }}
        >
          Bem-vindo ao Ofertiz
        </h2>

        {error && (
          <div
            style={{
              color: "red",
              marginBottom: "15px",
              padding: "10px",
              backgroundColor: "#ffebee",
              borderRadius: "var(--radius-sm)",
            }}
          >
            {error}
          </div>
        )}

        {!showEmailForm ? (
          <>
            <button
              style={socialButtonStyle}
              onClick={handleGoogleLogin}
              disabled={loading}
            >
              <img
                src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
                alt="Google"
                style={{ width: "20px", height: "20px" }}
              />
              {loading ? "Carregando..." : "Continuar com Google"}
            </button>

            <div
              style={{
                margin: "20px 0",
                color: "var(--text-secondary)",
                fontSize: "14px",
              }}
            >
              ou
            </div>

            <button
              style={socialButtonStyle}
              onClick={() => setShowEmailForm(true)}
            >
              <i className="fas fa-envelope"></i>
              Continuar com Email
            </button>

            <div
              style={{
                margin: "20px 0",
                color: "var(--text-secondary)",
                fontSize: "14px",
              }}
            >
              Ao continuar, você concorda com nossos Termos de Uso e Política de
              Privacidade.
            </div>
          </>
        ) : (
          <>
            <form onSubmit={handleEmailSubmit}>
              <input
                type="email"
                placeholder="seu@email.com"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                style={inputStyle}
                required
              />
              <input
                type="password"
                placeholder="Senha (mínimo 6 caracteres)"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                style={inputStyle}
                required
                minLength={6}
              />
              <button
                type="submit"
                style={submitButtonStyle}
                disabled={loading}
              >
                {loading ? (
                  <>
                    <i className="fas fa-spinner fa-spin"></i>{" "}
                    {isSignup ? "Criando conta..." : "Entrando..."}
                  </>
                ) : (
                  <>{isSignup ? "Criar Conta" : "Entrar"}</>
                )}
              </button>
            </form>

            <div
              style={{
                marginTop: "20px",
                fontSize: "14px",
                color: "var(--text-secondary)",
              }}
            >
              {isSignup ? (
                <p>
                  Já tem uma conta?{" "}
                  <button
                    onClick={() => setIsSignup(false)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "var(--primary-color)",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: "14px",
                    }}
                  >
                    Faça login
                  </button>
                </p>
              ) : (
                <p>
                  Não tem uma conta?{" "}
                  <button
                    onClick={() => setIsSignup(true)}
                    style={{
                      background: "none",
                      border: "none",
                      color: "var(--primary-color)",
                      cursor: "pointer",
                      textDecoration: "underline",
                      fontSize: "14px",
                    }}
                  >
                    Cadastre-se
                  </button>
                </p>
              )}
            </div>

            <button
              onClick={() => {
                setShowEmailForm(false);
                setError("");
                setEmail("");
                setPassword("");
              }}
              style={{
                marginTop: "20px",
                background: "none",
                border: "none",
                color: "var(--text-secondary)",
                cursor: "pointer",
                fontSize: "14px",
              }}
            >
              ← Voltar
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default Login;
